import {ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {NavLink} from 'react-router-dom';
import {twMerge} from 'tailwind-merge';

import Button from 'App/components/buttons/button';
import {selectFeatureFlag} from 'App/features/featureFlags/featureFlagsSlice';

type TProps = {
  to: string;
  text: string;
  icon: string;
  dataTest?: string;
  isMatch?: boolean;
};

const NavButton = ({
  to,
  text,
  icon,
  dataTest,
  isMatch,
}: TProps): ReactElement => {
  const isRedesignAvailable = useSelector(
    selectFeatureFlag('isRedesignAvailable'),
  );

  return (
    <NavLink to={to}>
      {({isActive}) => (
        <Button
          data-test="navlink"
          variant={isRedesignAvailable ? 'nav' : 'oldNav'}
          title={text}
          className={twMerge(
            'flex items-center',
            isRedesignAvailable
              ? 'px-[10px] py-[4px] font-normal'
              : 'px-[12px] py-[2px] font-semibold',
            (isActive || isMatch) &&
              (isRedesignAvailable
                ? 'bg-primary-100 bg-opacity-20 text-primary-dark text-opacity-100 hover:bg-opacity-25 hover:text-primary-dark'
                : 'bg-white text-green-500 hover:text-green-500'),
          )}
        >
          {!isRedesignAvailable && (
            <span className={twMerge(icon, 'text-2xl')} />
          )}
          <span className="ml-1.5 hidden xl:inline" data-test={dataTest}>
            {text}
          </span>
        </Button>
      )}
    </NavLink>
  );
};

export default NavButton;
